import React, { useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Text,
  Button,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { Users, CarTaxiFront, HandCoins } from "lucide-react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";
import DriverManagement from "../DriverManagement";
import VehicleManagement from "../VehicleManagement";
import PaymentProofsTable from "../PaymentProofs";

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

const DriverTabs = () => {
  return (
    <Box w="100%" p={4} mt={"70px"} ml={"9px"}>

      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={Users} label="Drivers" />
          <CustomTab icon={CarTaxiFront} label="Vehicles" />
          <CustomTab icon={HandCoins} label="Drivers Plans Payments" />
        </TabList>

        <TabPanels>
          <TabPanel>
            <DriverManagement />
          </TabPanel>
          <TabPanel>
            <VehicleManagement />
          </TabPanel>

          <TabPanel>
            <PaymentProofsTable />
          </TabPanel>

        </TabPanels>
      </Tabs>
    </Box>
  );
};


export default DriverTabs;
